module.exports = __webpack_public_path__ + "img/set.c1915955.png";